//TINY SLIDER
(function() {

    var forEachSlider = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
          callback.call(scope, i, array[i]); // passes back stuff we need
        }
    };

    //Difference slider
    /* eslint-disable no-unused-vars */
    var differenceSliders = document.querySelectorAll('.wpk-difference__container');
    if(differenceSliders > 0) {
        forEachSlider(differenceSliders, function (index, value) {

            let differenceSlider = tns({
                container: value,
                nav: true,
                navPosition: 'bottom',
                loop: false,
                items: 1
            });

        });
    }

    /*
    //Difference slider (single)
    if(document.querySelector('.wpk-difference__container')) {

        var differenceSlider = tns( {
            container: '.wpk-difference__container',
            nav: true,
            navPosition: 'bottom',
            loop: false,
            items: 1
        });

    }
    */

})();